import "./App.css";
import Header from "./components/Header";
import Slider from "./components/Slider";
import { FaTelegram, FaDiscord, FaXTwitter } from "react-icons/fa6";

function App() {
  return (
    <div className="App">
      <Header />
      <Slider />
      <div className="flex justify-center gap-6 mt-4 mb-1 text-2xl">
        <a
          href="https://discord.gg/vbry5bpfk4"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:text-[#5865F2] transition-colors duration-300"
        >
          <FaDiscord />
        </a>
        <a
          href="https://t.me/FileTrustian"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:text-[#229ED9] transition-colors duration-300"
        >
          <FaTelegram />
        </a>
        <a
          href="https://x.com/filetrustio?s=21"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:text-[#000000] transition-colors duration-300"
        >
          <FaXTwitter />
        </a>
      </div>
      <div className="text-center text-white/80 pb-5">
        © 2025, FileTrust - Version: 1.9.0
      </div>
    </div>
  );
}

export default App;
